<template>
  <div>
    <!-- 給与所得の源泉徴収税額（月額）計算 -->
    <el-dialog title="給与所得の源泉徴収税額（月額）計算" :visible.sync="dialogTax" width="50%" :destroy-on-close="true">
      <p>平成31年分以降の給与所得の源泉徴収税額（月額）を計算します。</p>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="social-container-a" label-position="left" label-width="0" v-loading="loading">
        <div>
          <el-row style="text-align:left; margin-left:26%">
            <el-col :span="24">
              <el-form-item prop="date" size="mini" >
                対象年月&nbsp;
                  <el-date-picker value-format="yyyy-MM" v-model="ruleForm.salaryDate" type="month" placeholder="選択" style="width: 35%;" :picker-options="pickerOptions"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          　<el-row style="text-align:left;">
            <el-col :span="24">
              <el-form-item prop="basic_salary">
                社会保険料控除後の給与等&nbsp;
                <el-input v-model="ruleForm.salary" size="mini" style="width: 26%;"></el-input>
                円 / 月
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="text-align:left;margin-left:23%">
            <el-col :span="24">
              <el-form-item prop="dependent_number">
                甲欄・乙欄&nbsp;
                <el-select v-model="ruleForm.dependent_number" size="mini" style="width: 50%;">
                  <el-option v-for="item in dependent_number" :key="item.id" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item style="width: 100%">
                <el-button type="primary" @click="taxCal" style="width: 50%;" size="mini">計算</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item style="width: 100%">
                <el-button type="primary" @click="clear" style="width: 50%;" size="mini">クリア</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div style="border-top:1px solid grey; text-align:center;">
          　<el-row style="margin-top:10px;">
            <el-col :span="24">
              <el-form-item>
                源泉徴収税額&nbsp;
                <el-input v-model="ruleForm.tax" size="mini" style="width: 30%;" readonly="readonly"></el-input>
                円
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div class="hint_style">
        <div class="hint_style_c">
          <h3>税額表を用いる計算</h3>
       </div>
        <div class="hint_style_d">
          <ul>
            <li>こちらの給与所得の源泉徴収税額（月額）計算は税額表を用いる計算です。電算機計算の特例計算を含まれません。</li>
            <li>「乙欄」は「給与所得者の扶養控除等申告書」の提出がない方に適用されます。</li>
            <li>扶養親族等の数については、税額計算上の人数です。詳細は下記関連リンク<a href="https://www.nta.go.jp/publication/pamph/gensen/zeigakuhyo2020/data/19-22.pdf">（給与所得の源泉徴収税額の求め方）</a>をご参照ください。</li>
            <li>税額は、1円未満の端数は切り捨て処理をしています。</li>
          </ul>
        </div>
      </div>
      <div class="hint_style">
        <div class="hint_style_a">
          <h3>関連リンク</h3>
       </div>
        <div class="hint_style_b">
          <a href="https://www.nta.go.jp/publication/pamph/gensen/zeigakuhyo2020/02.htm" target="view_window">国税庁）令和3年分 源泉徴収税額表</a><br>         
          <a href="https://www.nta.go.jp/publication/pamph/gensen/zeigakuhyo2019/01.htm" target="view_window">国税庁）令和2年分 源泉徴収税額表</a><br>               
          <a href="https://www.nta.go.jp/publication/pamph/gensen/zeigakuhyo2018/01.htm" target="view_window">国税庁）平成31年分 源泉徴収税額表</a><br>               
          <a href="https://www.nta.go.jp/publication/pamph/gensen/zeigakuhyo2020/data/19-22.pdf" target="view_window">国税庁）給与所得の源泉徴収税額の求め方</a>              
        </div>
      </div>
      <div style="text-align:left; padding-top:20px;padding-bottom:20px;">
      ※計算結果や情報等に関して当サイトは一切責任を負いません。また個別相談は一切対応しません。
      </div>       
    </el-dialog>
    <!-- 厚生年金保険料の計算 -->
    <el-dialog title="厚生年金保険料の計算" :visible.sync="dialogAnnuity" width="50%" :before-close="handleClose">
      <p>給与や賞与の報酬額から厚生年金保険の保険料および従業員の折半額を計算します。</p>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="social-container-a" label-position="left" label-width="0" v-loading="loading">
        <div>
          　<el-row  style="margin-left:20px;">
            <el-col :span="12">
              <el-form-item prop="salary" size="mini">
                報酬額&nbsp;
                <el-input v-model="ruleForm.salary" size="mini" style="width: 52%;"></el-input>
                円
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="salary" size="mini">
                <el-radio-group v-model="ruleForm.salaryType">
                  <el-radio label="給料"></el-radio>
                  <el-radio label="賞与"></el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="date" size="mini">
                対象年月&nbsp;
                <el-date-picker value-format="yyyy-MM" v-model="ruleForm.salaryDate" type="month" placeholder="選択" style="width: 49%;" :picker-options="pickerOptions"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="type" size="mini">
                <el-radio-group v-model="ruleForm.type">
                  <el-radio label="一般"></el-radio>
                  <el-radio label="坑内員・船員"></el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item style="width: 100%">
                <el-button type="primary" @click="annuityCal" style="width: 50%;" size="mini">計算</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item style="width: 100%">
                <el-button type="primary" @click="clear" style="width: 50%;" size="mini">クリア</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div style="border-top:1px solid grey; text-align:left;">
          　<el-row style="margin-top:10px;">
            <el-col :span="24">
              <el-form-item>
                <div>
                  標準報酬額&nbsp;
                  <el-input v-model="ruleForm.basic_salary" size="mini" style="width: 30%;" readonly="readonly"></el-input>&nbsp;円
                </div>
                <div style="margin-left:28px;">
                  保険料&nbsp;
                  <el-input v-model="ruleForm.annuity_total" size="mini" style="width: 32%;" readonly="readonly"></el-input>&nbsp;円
                  <el-input v-model="ruleForm.annuity_total_rate" size="mini" style="width: 18%;" readonly="readonly"></el-input>&nbsp;%
                </div>
                <div style="margin-left:15px;">
                  従業員分&nbsp;
                  <el-input v-model="ruleForm.annuity_half" size="mini" style="width: 31%;" readonly="readonly"></el-input>&nbsp;円
                  <el-input v-model="ruleForm.annuity_half_rate" size="mini" style="width: 17%;" readonly="readonly"></el-input>&nbsp;%
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div class="hint_style">
        <div class="hint_style_a">
          <h3>報酬額</h3>
       </div>
        <div class="hint_style_b">
          基本給、諸手当（扶養手当、地域手当、通勤手当等）などは報酬額に含めます。見舞金、出張旅費、慶弔費、交際費などは報酬額に含めません。また年4回以上支給される賞与は給与に含めて計算します。
        </div>
      </div>
      <div class="hint_style">
        <div class="hint_style_a">
          <h3>計算式</h3>
       </div>
        <div class="hint_style_b">
          <span style="font-weight:bold;">厚生年金保険料:</span>
          <span>標準報酬月額(または標準賞与額) × 厚生年金保険料率</span>         
        </div>
      </div>
      <div class="hint_style">
        <div class="hint_style_a">
          <h3>関連リンク</h3>
       </div>
        <div class="hint_style_b">
          <a href="https://www.nenkin.go.jp/service/kounen/hokenryo/ryogaku/index.html" target="view_window">厚生年金保険料額表等</a><br>         
        </div>
      </div>
      <div style="text-align:left; padding-top:20px;padding-bottom:20px;">
      ※計算結果や情報等に関して当サイトは一切責任を負いません。また個別相談は一切対応しません。
      </div>      
    </el-dialog>
    <!-- 健康保険料の計算 -->
    <el-dialog title="健康保険料の計算" :visible.sync="dialogSocialIns" width="50%" :before-close="handleClose">
      <p style="text-align:left;">
        給与や賞与の報酬額から平成31年度以降の健康保険料、介護保険料とその従業員の負担額を計算します。
      </p>
      <div class="social-container">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm"  label-position="left" label-width="0" v-loading="loading">
        <div>
          <el-row>
            <el-col :span="24">
              <div style="text-align:left;margin-left:7%;">
                <el-form-item prop="date" size="mini">
                  対象年月&nbsp;
                  <el-date-picker value-format="yyyy-MM" v-model="ruleForm.salaryDate" type="month" placeholder="選択" style="width: 26%;" :picker-options="pickerOptions"></el-date-picker>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div style="text-align:left;margin-left:13%;">
              <el-form-item prop="age">
                年齢&nbsp;
                <el-select v-model="ruleForm.age" size="mini" style="width: 50%;">
                  <el-option v-for="item in age" :key="item.id" :label="item.label" :value="item.value"></el-option>
                </el-select> 　　
              </el-form-item>
              </div>
            </el-col>
          </el-row>
          　<el-row>
              <div style="text-align:left;margin-left:10%;">
            <el-col :span="13">
              <el-form-item prop="basic_salary">
                報酬額&nbsp;
                <el-input v-model="ruleForm.basic_salary" size="mini" style="width: 50%;"></el-input>
                円
              </el-form-item>
            </el-col>
            <el-col :span="11" style="text-align:left;">
              <el-form-item prop="hSalaryType">
                <el-radio-group v-model="ruleForm.hSalaryType">
                  <el-radio label="給与"></el-radio>
                  <el-radio label="賞与"></el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
              </div>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item prop="address">
                <div style="text-align:left;">
                  事業所所在地&nbsp;
                  <el-select v-model="ruleForm.address" size="mini" style="width: 25%;" placeholder="選択">
                    <el-option v-for="item in locationList" :key="item.id" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item style="width: 100%">
                <el-button type="primary" @click="calculate" style="width: 50%;" size="mini">計算</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item style="width: 100%">
                <el-button type="primary" @click="clear" style="width: 50%;" size="mini">クリア</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div style="border-top:1px solid grey; text-align:left;">
          <el-row>
            <el-col :span="16">
              <div style="margin-top:30px;">
                <table style="width:100%">
                  <tr>
                    <th class="th_style">保険の種類</th>
                    <th class="th_style">保険料</th>
                    <th class="th_style">料率</th>
                    <th class="th_style">従業員分</th>
                  </tr>
                  <tr>
                    <td class="th_style">
                      <span v-if="ruleForm.h_half != ''">健康保険</span>
                    </td>
                    <td>{{ruleForm.h_total}}</td>
                    <td>{{ruleForm.h_rate}}</td>
                    <td>{{ruleForm.h_half}}</td>
                  </tr>
                  <tr v-if="ruleForm.c_half != ''">
                    <td class="th_style">介護保険</td>
                    <td>{{ruleForm.c_total}}</td>
                    <td>{{ruleForm.c_rate}}</td>
                    <td>{{ruleForm.c_half}}</td>
                  </tr>
                  <tr v-if="ruleForm.h_c_half != ''">
                    <td class="th_style">保険合計</td>
                    <td>{{ruleForm.h_c_total}}</td>
                    <td>{{ruleForm.h_c_rate}}</td>
                    <td>{{ruleForm.h_c_half}}</td>
                  </tr>
                </table>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-form>
      </div>
      <div class="hint_style">
        <div class="hint_style_a">
          <h3>報酬額</h3>
       </div>
        <div class="hint_style_b">
          基本給、諸手当（扶養手当、地域手当、通勤手当等）などは報酬額に含めます。見舞金、出張旅費、慶弔費、交際費などは報酬額に含めません。また年4回以上支給される賞与は給与に含めて計算します。
        </div>
      </div>
      <div class="hint_style">
        <div class="hint_style_c">
          <h3>計算式</h3>
       </div>
        <div class="hint_style_d">
          <ul>
            <li>
              <span style="font-weight:bold;">健康保険料:</span>  
              <span>標準報酬月額(または標準賞与額) × 健康保険料率</span>
            </li>
            <li>
              <span style="font-weight:bold;">介護保険料:</span> 
              <span>標準報酬月額(または標準賞与額) × 介護保険料率　(40歳から64までの方のみ)</span>
            </li>   
          </ul>      
        </div>
      </div>
      <div class="hint_style">
        <div class="hint_style_a">
          <h3>関連リンク</h3>
       </div>
        <div class="hint_style_b">
          <a href="https://www.kyoukaikenpo.or.jp/g7/cat330/sb3130/" target="view_window">都道府県毎の保険料率</a><br>         
          <a href="https://www.kyoukaikenpo.or.jp/g3/cat320/sb3160/sbb3165/1962-231/" target="view_window">標準報酬月額・標準賞与額とは？</a><br>               
        </div>
      </div>
      <div style="text-align:left; padding-top:20px;padding-bottom:20px;">
      ※計算結果や情報等に関して当サイトは一切責任を負いません。また個別相談は一切対応しません。
      </div>           
    </el-dialog>
    <!-- 源泉徴収票（給与所得） -->
    <el-dialog title="給与所得者の源泉徴収票の計算" :visible.sync="dialogTaxForm" width="50%" :before-close="handleClose">
      <p style="text-align:left;">
        給与所得者の源泉徴収票を計算します。
      </p>
      <div style="margin:50px;">
        <el-form :model="taxForm" :rules="rules" ref="taxForm"  label-position="left" v-loading="loading">
          <div style="text-align:left;">
            <div style="border-bottom:1px solid grey; text-align:left; margin-bottom:30px;">
              <el-row>
                <el-col :span="24">
                  <el-form-item prop="taxFormDate" size="mini">
                    年度&nbsp;                  
              　    <el-select style="width:100px;" v-model="taxForm.taxFormDate" size="mini" :placeholder="$t('general.select')">
                　    <el-option v-for="item in taxFormDate" :key="item.id" :label="item.label" :value="item.value"></el-option>
              　    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <el-row>
              <el-col :span="24">
                ＜受給者＞              
                <el-form-item>
                  <div style="margin-left:173px;">
                    年収&nbsp;
                    <el-input v-model="taxForm.income" size="mini" style="width: 100px;"></el-input>
                    円&nbsp;&nbsp;支払金額
                  </div>　
                  <div style="margin-left:160px;">
                    障害者&nbsp;
                    <el-radio-group v-model="taxForm.disabled">
                      <el-radio label="一般">一般</el-radio>
                      <el-radio label="特別">特別</el-radio>
                      <el-radio label="でない">でない</el-radio>
                    </el-radio-group>
                  </div>
                  <div style="margin-left:43px;">
                    寡婦/ひとり親の控除対象&nbsp;
                    <el-radio-group v-model="taxForm.single">
                      <el-radio label="寡婦">寡婦</el-radio>
                      <el-radio label="ひとり親">ひとり親</el-radio>
                      <el-radio label="でない">でない</el-radio>
                    </el-radio-group>
                  </div>
                  <div style="margin-left:145px;">
                    勤労学生&nbsp;
                    <el-radio-group v-model="taxForm.student">
                      <el-radio label="である">である</el-radio>
                      <el-radio label="でない">でない</el-radio>
                    </el-radio-group>
                  </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              ＜配偶者＞              
              <el-form-item>
                <div style="margin-left:145px;">
                  控除対象&nbsp;
                  <el-radio-group v-model="taxForm.spousal_is_deductible">
                    <el-radio label="無">無</el-radio>
                    <el-radio label="有(一般)">有(一般)</el-radio>
                    <el-radio label="有(老人70歳〜)">有(老人70歳〜)</el-radio>
                  </el-radio-group>
                </div>
                <div style="margin-left:104px;">
                  配偶者合計所得&nbsp;
                  <el-input v-model="taxForm.spousal_income" size="mini" style="width: 100px;"></el-input>
                  円&nbsp;&nbsp;除く必要経費（給与所得控除など）
                </div>                　
              </el-form-item>
            </el-col>
          </el-row>          
          <el-row>
            <el-col :span="24">
              ＜扶養親族の数＞（配偶者除く）             
              <el-form-item style="margin-left:108px;">
                一般(16~18歳)	&nbsp;
                <el-input v-model="taxForm.number1" size="mini" style="width: 100px;"></el-input>
                人
                <br>
                特定(19~22歳)	&nbsp;
                <el-input v-model="taxForm.number2" size="mini" style="width: 100px;"></el-input>
                人　
                <br>
                成年(23~69歳) &nbsp;
                <el-input v-model="taxForm.number3" size="mini" style="width: 100px;"></el-input>
                人
                <div style="margin-left:15px;">
                  老親(70歳~) &nbsp;
                  <el-input v-model="taxForm.number4" size="mini" style="width: 100px;"></el-input>
                  人&nbsp;&nbsp;
                  うち同居 &nbsp;
                  <el-input v-model="taxForm.number5" size="mini" style="width: 100px;"></el-input> 
                  人
                </div>                                   　
              </el-form-item>
            </el-col>              
          </el-row>                  
          <el-row>
            <el-col :span="24">
              ＜障害者の数＞（受給者除く）             
              <el-form-item style="margin-left:128px;">
                 一般障害者	&nbsp;
                <el-input v-model="taxForm.number6" size="mini" style="width: 100px;"></el-input>
                人&nbsp;&nbsp;
                <br>
                特別障害者 &nbsp;
                <el-input v-model="taxForm.number7" size="mini" style="width: 100px;"></el-input>
                人&nbsp;&nbsp;
                うち同居 &nbsp;
                <el-input v-model="taxForm.number8" size="mini" style="width: 100px;"></el-input> 
                人 　
              </el-form-item>
            </el-col>              
          </el-row>
          <el-row>
            <el-col :span="24">
              ＜所得金額特別控除＞              
              <el-form-item style="margin-left:70px;" prop="number9">
                23歳未満の子供の数 &nbsp;
                <el-input v-model="taxForm.number9" size="mini" style="width: 100px;"></el-input>
                &nbsp;&nbsp;※所得金額調整控除の判断に使用                                    　
              </el-form-item>
            </el-col>              
          </el-row>
          <el-row>
            <el-col :span="24">
              <div style="text-align:left;">＜保険料等の控除＞</div>              
              <el-form-item>
                 社会保険料等の金額	&nbsp;
                <el-input v-model="taxForm.ins1" size="mini" style="width: 100px;"></el-input>
                円&nbsp;&nbsp;含む小規模企業共済等掛金
                <br>
                生命保険料の控除額 &nbsp;
                <el-input v-model="taxForm.ins2" size="mini" style="width: 100px;"></el-input>
                円&nbsp;&nbsp;一般生命/介護医療/個人年金の控除額合計で最高12万円&nbsp;&nbsp;
                <br>
                地震保険料の控除額 &nbsp;
                <el-input v-model="taxForm.ins3" size="mini" style="width: 100px;"></el-input> 
                円&nbsp;&nbsp;最高5万円 　
              </el-form-item>
            </el-col>              
          </el-row>          
          <el-row>
            <el-col :span="24">
              <div style="text-align:left;">＜住宅取得等の控除＞</div>              
              <el-form-item>
                住宅取得等特別控除額	&nbsp;
                <el-input v-model="taxForm.house" size="mini" style="width: 100px;"></el-input>
                円
              </el-form-item>
            </el-col>              
          </el-row>
          </div> 
          <div>    
          <el-row>
            <el-col :span="12">
              <el-form-item style="width: 100%">
                <el-button type="primary" @click="taxFormCalculate()" style="width: 50%;" size="mini">計算</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item style="width: 100%">
                <el-button type="primary" @click="clear_tax" style="width: 50%;" size="mini">クリア</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div style="border-top:1px solid grey;">
          <el-row align="center" style="margin-left:150px; margin-right:150px;">
            <el-col :span="24">
              <div style="margin-top:30px;">
                <table style="width:100%;">
                  <tr>
                    <th class="th_style">項目</th>
                    <th class="th_style">金額</th>
                  </tr>
                  <tr>
                    <td class="th_style">                      
                      <span v-if="taxForm.income1 != '' || taxForm.income1 === 0">支払金額</span>
                    </td>
                    <td>{{taxForm.income1}}</td>
                  </tr>
                  <tr v-if="taxForm.deduction1 != '' || taxForm.deduction2 === 0">
                    <td class="th_style">給与所得控除の金額</td>
                    <td>{{taxForm.deduction1}}</td>
                  </tr>
                  <tr v-if="taxForm.deduction2 != '' || taxForm.deduction2 === 0">
                    <td class="th_style">所得金額調整控除</td>
                    <td>{{taxForm.deduction2}}</td>
                  </tr>
                  <tr v-if="taxForm.deduction3 != '' || taxForm.deduction2 === 0">
                    <td class="th_style">給与所得控除後の金額</td>
                    <td>{{taxForm.deduction3}}</td>
                  </tr>
                  <tr v-if="taxForm.deduction4 != '' || taxForm.deduction2 === 0">
                    <td class="th_style">基礎控除</td>
                    <td>{{taxForm.deduction4}}</td>
                  </tr>                                    
                  <tr v-if="taxForm.deduction5 != '' || taxForm.deduction5 === 0">
                    <td class="th_style">配偶者（特別）控除</td>
                    <td>{{taxForm.deduction5}}</td>
                  </tr>                                    
                  <tr v-if="taxForm.deduction6 != '' || taxForm.deduction5 === 0">
                    <td class="th_style">扶養控除</td>
                    <td>{{taxForm.deduction6}}</td>
                  </tr>                                    
                  <tr v-if="taxForm.deduction7 != '' || taxForm.deduction5 === 0">
                    <td class="th_style">扶養障害控除</td>
                    <td>{{taxForm.deduction7}}</td>
                  </tr>                                    
                  <tr v-if="taxForm.deduction8 != '' || taxForm.deduction5 === 0">
                    <td class="th_style">受給者控除</td>
                    <td>{{taxForm.deduction8}}</td>
                  </tr>                                    
                  <tr v-if="taxForm.deduction9 != '' || taxForm.deduction5 === 0">
                    <td class="th_style">保険料等控除</td>
                    <td>{{taxForm.deduction9}}</td>
                  </tr>                                    
                  <tr v-if="taxForm.amount1 != '' || taxForm.deduction2 === 0">
                    <td class="th_style">所得控除の額の合計額</td>
                    <td>{{taxForm.amount1}}</td>
                  </tr>                                    
                  <tr v-if="taxForm.amount2 != '' || taxForm.deduction2 === 0">
                    <td class="th_style">課税される所得金額</td>
                    <td>{{taxForm.amount2}}</td>
                  </tr>                                    
                  <tr v-if="taxForm.amount3 != '' || taxForm.deduction2 === 0">
                    <td class="th_style">所得税額</td>
                    <td>{{taxForm.amount3}}</td>
                  </tr>                                    
                  <tr v-if="taxForm.deduction10 != '' || taxForm.deduction5 === 0">
                    <td class="th_style">住宅取得等特別控除</td>
                    <td>{{taxForm.deduction10}}</td>
                  </tr>                                    
                  <tr v-if="taxForm.tax1 != '' || taxForm.deduction2 === 0">
                    <td class="th_style">源泉徴収税額</td>
                    <td>{{taxForm.tax1}}</td>
                  </tr>
                  <tr v-if="taxForm.tax2 != '' || taxForm.deduction2 === 0">
                    <td class="th_style">福與特別所得税分</td>
                    <td>{{taxForm.tax2}}</td>
                  </tr>                                                      
                </table>
              </div>
            </el-col>
          </el-row>
        </div>
        </el-form>
      </div>
      <div class="hint_style">
        <div class="hint_style_a">
          <h3>給与所得の金額の計算</h3>
       </div>
        <div class="hint_style_b">
          給与の収入金額から給与所得控除額を差し引いて給与所得の金額を算出します。
        </div>
      </div>      
      <div class="hint_style">
        <div class="hint_style_c">
          <h3>計算式</h3>
       </div>
        <div class="hint_style_d">
          <ul>
            <li>
              <span style="font-weight:bold;">給与所得控除後の金額:</span>  
              <span>給与所得の金額 - 所得金額調整控除額</span>
            </li>
            <li>
              <span style="font-weight:bold;">所得控除の額の合計額:</span>  
              <span>基礎控除 + 配偶者（特別）控除 + 扶養控除 + 扶養障害控除 + 受給者控除 + 保険料等控除</span>
            </li>                          
          </ul>      
        </div>
      </div>
      <div class="hint_style">
        <div class="hint_style_c">
          <h3>所得金額調整控除</h3>
       </div>
        <div class="hint_style_d">
          <ul>
            <li> 
              <span>令和2年から、年収850万超の場合に、扶養親族等の条件により、所得金額調整控除が適用されます。</span>
            </li>  
            <li>
              <span style="font-weight:bold;">所得金額調整控除額:</span>  
              <span>給与等の収入金額(1,000万円超の場合は1,000万円) － 850万円}×10％</span><br>
              <span>※　1円未満の端数があるときは、その端数を切り上げます。</span>
            </li>  
          </ul>      
        </div>
      </div> 
      <div class="hint_style">
        <div class="hint_style_c">
          <h3>寡婦・ひとり親控除</h3>
       </div>
        <div class="hint_style_d">
          <ul>
            <li> 
              <span>控除を受ける納税者本人の合計所得金額が500万円を超える場合は、寡婦・ひとり親控除は受けられません。</span>
            </li> 
          </ul>      
        </div>
      </div>                 
      <div class="hint_style">
        <div class="hint_style_c">
          <h3>配偶者控除</h3>
       </div>
        <div class="hint_style_d">
          <ul>
            <li> 
              <span>平成30年分以後は、控除を受ける納税者本人の合計所得金額が1,000万円を超える場合は、配偶者控除は受けられません。</span>
            </li>  
            <li>
              <span>年間の合計所得金額が48万円以下である方が適用されます。</span>
            </li>  
            <li>
              <span>配偶者控除の適用がない方で、納税者本人の合計所得金額が1,000万円以下であり、かつ、配偶者の合計所得金額が48万円超133万円以下である方については、配偶者特別控除の適用を受けることができます。</span>
            </li>  
          </ul>      
        </div>
      </div>                       
      <div class="hint_style">
        <div class="hint_style_a">
          <h3>源泉徴収税額及び復興特別所得税分の計算</h3>
       </div>
        <div class="hint_style_b">
          所得税額から、（（特定増改築等）住宅借入金等特別控除額などの）所得税額から差し引かれる金額を差し引いた後の金額と、その金額に2.1％を掛けて計算した復興特別所得税額を合計し、源泉徴収税額及び復興特別所得税の額を計算します。
          <br>
          ◎100円未満端数切捨て
        </div>
      </div>               
      <div class="hint_style">
        <div class="hint_style_a">
          <h3>関連リンク</h3>
       </div>
        <div class="hint_style_b">
          <a href="https://www.nta.go.jp/publication/pamph/koho/kurashi/html/02_1.htm" target="view_window">給与所得者と税</a><br>         
          <a href="https://www.nta.go.jp/taxes/shiraberu/taxanswer/shotoku/1410.htm" target="view_window">給与所得控除</a><br>         
          <a href="https://www.nta.go.jp/taxes/shiraberu/taxanswer/shotoku/1411.htm" target="view_window">所得金額調整控除</a><br>        
          <a href="https://www.nta.go.jp/taxes/shiraberu/taxanswer/shotoku/1199.htm" target="view_window">基礎控除</a><br>        
          <a href="https://www.nta.go.jp/taxes/shiraberu/taxanswer/shotoku/1191.htm" target="view_window">配偶者控除</a><br>        
          <a href="https://www.nta.go.jp/taxes/shiraberu/taxanswer/shotoku/1195.htm" target="view_window">配偶者特別控除</a><br>        
          <a href="https://www.nta.go.jp/taxes/shiraberu/taxanswer/shotoku/1180.htm" target="view_window">扶養控除</a><br>        
          <a href="https://www.nta.go.jp/taxes/shiraberu/taxanswer/shotoku/1160.htm" target="view_window">障害者控除</a><br>        
          <a href="https://www.nta.go.jp/taxes/shiraberu/taxanswer/shotoku/1170.htm" target="view_window">寡婦控除</a><br>        
          <a href="https://www.nta.go.jp/taxes/shiraberu/taxanswer/shotoku/1171.htm" target="view_window">ひとり親控除</a><br>        
          <a href="https://www.nta.go.jp/taxes/shiraberu/taxanswer/shotoku/1175.htm" target="view_window">勤労学生控除</a><br>        
        </div>
      </div>
      <div style="text-align:left; padding-top:20px;padding-bottom:20px;">
      ※計算結果や情報等に関して当サイトは一切責任を負いません。また個別相談は一切対応しません。
      </div>           
    </el-dialog>
    <!-- 计算首页 -->
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="register-container" label-position="left" label-width="0" v-loading="loading">
      <div>
        <a href="https://www.hrbox.jp/"><img :src="require('@/assets/LOGO004.jpg')" style="width: 160px; height: 56px;" /></a>
      </div>
      <el-link @click="dialogSocialInsFun()" target="_blank">健康保険料の計算</el-link>
      <br>
      <br>
      <el-link @click="dialogAnnuityFun()" target="_blank">厚生年金保険料の計算</el-link>
      <br>
      <br>
      <el-link @click="dialogTaxFun()" target="_blank">給与所得の源泉徴収税額（月額）計算</el-link>
      <br>
      <br>
      <el-link @click="dialogTaxFormFun()" target="_blank">源泉徴収票（給与所得）</el-link>
      <br>      
    </el-form>
  </div>
</template>

<script>

export default {
  data() {
    return {
       pickerOptions: {
        disabledDate(time) {
          var Dtime = new Date('2019-3-1 00:00:00').getTime();
          // return time.getTime() > Date.now() + 30 * 8.64e7;
          return time.getTime() < Dtime || time.getTime() > Date.now() + 30 * 8.64e7;
        },
      },
      dialogAnnuity: false,
      dialogSocialIns: false,
      dialogTax: false,
      dialogTaxForm: false,
      ruleForm: {
        age: "0",
        salary: "",
        basic_salary: "",
        hSalaryType: "給与",
        salaryType: "給料",
        address: "東京都",
        date: "",
        h_half: "",
        c_half: "",
        h_c_half: "",
        h_total: "",
        c_total: "",
        h_c_total: "",
        annuity_half: "",
        annuity_total: "",
        type: "一般",
        annuity_half_rate: "",
        annuity_total_rate: "",
        tax:"",
        dependent_number:"",
        h_rate:"",
        c_rate:"",
        h_c_rate:"",
        //源泉徴収票
        taxFormDate:"",
        income:"",
        disabled:"",
        single:"",
        student:"",
        spousal_is_deductible:"",
        spousal_income:"",
        number1:"",
        number2:"",
        number3:"",
        number4:"",
        number5:"",
        number6:"",
        number7:"",
        number8:"",
        number9:"",
        ins1:"",
        ins2:"",
        ins3:"",
        house:"",
        income1:"",
        deduction1:"",
        deduction2:"",
        deduction3:"",
        deduction4:"",
        deduction5:"",
        deduction6:"",
        deduction7:"",
        deduction8:"",
        amount1:"",
        amount2:"",
        amount3:"",
        tax1:"",
        tax2:""
      },
      //源泉徴収票
      taxForm: {
        taxFormDate:"令和2年",
        income:0,
        disabled:"でない",
        single:"でない",
        student:"でない",
        spousal_is_deductible:"無",
        spousal_income:0,
        number1:0,
        number2:0,
        number3:0,
        number4:0,
        number5:0,
        number6:0,
        number7:0,
        number8:0,
        number9:0,
        ins1:0,
        ins2:0,
        ins3:0,
        house:0,
        income1:"",
        deduction1:"",
        deduction2:"",
        deduction3:"",
        deduction4:"",
        deduction5:"",
        deduction6:"",
        deduction7:"",
        deduction8:"",
        deduction9:"",
        deduction10:"",
        amount1:"",
        amount2:"",
        amount3:"",
        tax1:"",
        tax2:""
      },      
      age: [
        {
          label: "40歳未満",
          value: "0",
        },
        {
          label: "40歳以上65歳未満",
          value: "41",
        },
        {
          label: "65歳以上",
          value: "65",
        },
        {
          label: "70歳以上",
          value: "70",
        },
      ],
      locationList: [
        {
          value: "北海道",
          label: this.$t("NKHK.hokkaido"),
        },
        {
          value: "青森県",
          label: this.$t("NKHK.aomori"),
        },
        {
          value: "岩手県",
          label: this.$t("NKHK.iwate"),
        },
        {
          value: "宮城県",
          label: this.$t("NKHK.miyagi"),
        },
        {
          value: "秋田県",
          label: this.$t("NKHK.akita"),
        },
        {
          value: "山形県",
          label: this.$t("NKHK.yamagata"),
        },
        {
          value: "福島県",
          label: this.$t("NKHK.fukushima"),
        },
        {
          value: "茨城県",
          label: this.$t("NKHK.ibaraki"),
        },
        {
          value: "栃木県",
          label: this.$t("NKHK.tochigi"),
        },
        {
          value: "群馬県",
          label: this.$t("NKHK.gunma"),
        },
        {
          value: "埼玉県",
          label: this.$t("NKHK.saitama"),
        },
        {
          value: "千葉県",
          label: this.$t("NKHK.chiba"),
        },
        {
          value: "東京都",
          label: this.$t("NKHK.tokyo"),
        },
        {
          value: "神奈川県",
          label: this.$t("NKHK.kanagawa"),
        },
        {
          value: "新潟県",
          label: this.$t("NKHK.niigata"),
        },
        {
          value: "富山県",
          label: this.$t("NKHK.toyama"),
        },
        {
          value: "石川県",
          label: this.$t("NKHK.ishikawa"),
        },
        {
          value: "福井県",
          label: this.$t("NKHK.fukui"),
        },
        {
          value: "山梨県",
          label: this.$t("NKHK.yamanashi"),
        },
        {
          value: "長野県",
          label: this.$t("NKHK.nagano"),
        },
        {
          value: "岐阜県",
          label: this.$t("NKHK.gifu"),
        },
        {
          value: "静岡県",
          label: this.$t("NKHK.shizuoka"),
        },
        {
          value: "愛知県",
          label: this.$t("NKHK.aichi"),
        },
        {
          value: "三重県",
          label: this.$t("NKHK.mie"),
        },
        {
          value: "滋賀県",
          label: this.$t("NKHK.shiga"),
        },
        {
          value: "京都府",
          label: this.$t("NKHK.kyoto"),
        },
        {
          value: "大阪府",
          label: this.$t("NKHK.osaka"),
        },
        {
          value: "兵庫県",
          label: this.$t("NKHK.hyogo"),
        },
        {
          value: "奈良県",
          label: this.$t("NKHK.nara"),
        },
        {
          value: "和歌山県",
          label: this.$t("NKHK.wakayama"),
        },
        {
          value: "鳥取県",
          label: this.$t("NKHK.tottori"),
        },
        {
          value: "島根県",
          label: this.$t("NKHK.shimane"),
        },
        {
          value: "岡山県",
          label: this.$t("NKHK.okayama"),
        },
        {
          value: "広島県",
          label: this.$t("NKHK.hiroshima"),
        },
        {
          value: "山口県",
          label: this.$t("NKHK.yamaguchi"),
        },
        {
          value: "徳島県",
          label: this.$t("NKHK.tokushima"),
        },
        {
          value: "香川県",
          label: this.$t("NKHK.kagawa"),
        },
        {
          value: "愛媛県",
          label: this.$t("NKHK.ehime"),
        },
        {
          value: "高知県",
          label: this.$t("NKHK.kochi"),
        },
        {
          value: "福岡県",
          label: this.$t("NKHK.fukuoka"),
        },
        {
          value: "佐賀県",
          label: this.$t("NKHK.saga"),
        },
        {
          value: "長崎県",
          label: this.$t("NKHK.nagasaki"),
        },
        {
          value: "熊本県",
          label: this.$t("NKHK.kumamoto"),
        },
        {
          value: "大分県",
          label: this.$t("NKHK.oita"),
        },
        {
          value: "宮崎県",
          label: this.$t("NKHK.miyazaki"),
        },
        {
          value: "鹿児島県",
          label: this.$t("NKHK.kagoshima"),
        },
        {
          value: "沖縄県",
          label: this.$t("NKHK.okinawa"),
        },
      ],
      tableData: [
      ],
      loading: false,
      dependent_number: [
        {
          label: "甲欄の扶養親族0人",
          value: "0",
        },
        {
          label: "甲欄の扶養親族1人",
          value: "1",
        },
        {
          label: "甲欄の扶養親族2人",
          value: "2",
        },
        {
          label: "甲欄の扶養親族3人",
          value: "3",
        },
        {
          label: "甲欄の扶養親族4人",
          value: "4",
        },
        {
          label: "甲欄の扶養親族5人",
          value: "5",
        },
        {
          label: "甲欄の扶養親族6人",
          value: "6",
        },
        {
          label: "甲欄の扶養親族7人",
          value: "7",
        },
        {
          label: "乙欄",
          value: "B",
        },
      ],
      //年度
      taxFormDate: [
        {
          label: "令和2年",
          value: "令和2年",
        },
        {
          label: "令和3年",
          value: "令和3年",
        }
      ],      
    };
  },
  methods: {
    dialogSocialInsFun(){

      this.dialogSocialIns = true;
      this.clear();
      
    },
    dialogAnnuityFun(){
      
      this.dialogAnnuity = true;
      this.clear();
    },
    dialogTaxFun(){
      this.clear();
      this.dialogTax = true;
    },
    dialogTaxFormFun(){
      this.clear_tax();
      this.dialogTaxForm = true;
    },
    //厚生年金計算
    annuityCal() {
      if (this.ruleForm.salaryDate != null && this.ruleForm.salaryDate != undefined) {
        var salaryDateStr = this.ruleForm.salaryDate;
        var salaryDateArr = salaryDateStr.split("-");
        let postData = this.qs.stringify({
          salary: this.ruleForm.salary,
          year: salaryDateArr[0],
          month: salaryDateArr[1],
          salaryType: this.ruleForm.salaryType,
        });
        this.axios({
          method: "post",
          url: "/website/annuityCal",
          data: postData,
        })
          .then((response) => {
            this.ruleForm.basic_salary = (Math.round(response.data.basic_salary)).toLocaleString();
            this.ruleForm.annuity_half = (Math.round(response.data.annuity_half)).toLocaleString();
            this.ruleForm.annuity_total = (Math.round(response.data.annuity_total)).toLocaleString();
            this.ruleForm.annuity_half_rate = "9.15";
            this.ruleForm.annuity_total_rate = "18.3";
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    //税計算
    taxCal(){
      if (this.ruleForm.salaryDate != null && this.ruleForm.salaryDate != undefined) {
        var salaryDateStr = this.ruleForm.salaryDate;
        var salaryDateArr = salaryDateStr.split("-");
        let postData = this.qs.stringify({
          salary: this.ruleForm.salary,
          year: salaryDateArr[0],
          month: salaryDateArr[1],
          DependentNum:this.ruleForm.dependent_number,
        });
        this.axios({
          method: "post",
          url: "/website/taxCal",
          data: postData,
        })
          .then((response) => {
            this.ruleForm.tax = (Math.round(response.data)).toLocaleString();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    //健康保険料計算
    calculate() {
      if (this.ruleForm.salaryDate != null && this.ruleForm.salaryDate != undefined) {
        var salaryDateStr = this.ruleForm.salaryDate;
        var salaryDateArr = salaryDateStr.split("-");
        let postData = this.qs.stringify({
          salary: this.ruleForm.basic_salary,
          year: salaryDateArr[0],
          month: salaryDateArr[1],
          age: this.ruleForm.age,
          location: this.ruleForm.address,
          salaryType: this.ruleForm.hSalaryType,
        });
        this.axios({
          method: "post",
          url: "/website/srateCalculate",
          data: postData,
        })
          .then((response) => {
            this.tableData = response.data;
            this.ruleForm.h_half = (Math.round(this.tableData.h_half)).toLocaleString();
            this.ruleForm.c_half = (Math.round(Number(this.tableData.h_c_half) - Number(this.tableData.h_half))).toLocaleString();
            this.ruleForm.h_c_half = (Math.round(this.tableData.h_c_half)).toLocaleString();
            this.ruleForm.h_total = (Math.round(this.tableData.h_total)).toLocaleString();
            this.ruleForm.c_total = (Math.round(Number(this.tableData.h_c_total) - Number(this.tableData.h_total))).toLocaleString();
            this.ruleForm.h_c_total = (Math.round(this.tableData.h_c_total)).toLocaleString();
            this.ruleForm.h_rate = this.tableData.h_rate + "%";
            this.ruleForm.c_rate = this.tableData.c_rate + "%";
            this.ruleForm.h_c_rate = (Number(this.tableData.h_rate ) + Number(this.tableData.c_rate )).toFixed(2)  + "%";
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    //給与所得者の源泉徴収票計算
    taxFormCalculate() {     
      //支払金額（年収）
      this.taxForm.income1 = (Number(this.taxForm.income)).toLocaleString();
      //令和2年分以降計算
      if (this.taxForm.taxFormDate === "令和2年" || this.taxForm.taxFormDate === "令和3年") {
        //給与所得控除額（令和２年分）の計算表により給与所得控除の金額を計算
        var A = 0;
        if(this.taxForm.income > 0 && this.taxForm.income <= 1625000){
          A = 550000;

        }else if(this.taxForm.income >= 1625001 && this.taxForm.income <= 1800000){
          A = Number(this.taxForm.income) * 0.4 -100000;

        }else if(this.taxForm.income >= 1800001 && this.taxForm.income <= 3600000){
          A = Number(this.taxForm.income) * 0.3  + 80000;

        }else if(this.taxForm.income >= 3600001 && this.taxForm.income <= 6600000){
          A = Number(this.taxForm.income) * 0.2 + 440000;

        }else if(this.taxForm.income >= 6600001 && this.taxForm.income <= 8500000){
          A = Number(this.taxForm.income) * 0.1 + 1100000;

        }else if(this.taxForm.income >= 8500001){
          A = 1950000;
        }
        this.taxForm.deduction1 = Math.round(A).toLocaleString();

        //所得金額調整控除
        var B = 0;
        if(this.taxForm.income > 8500000){
          if(this.taxForm.number9 > 0){
            this.taxForm.income = this.taxForm.income >= 10000000 ? 1000000 : this.taxForm.income ;
            //小于1円进
            B = Math.ceil((Number(this.taxForm.income) - 8500000) * 0.1) ;
          }
        }else{
          B = 0;
        }
        this.taxForm.deduction2 = B.toLocaleString();

        //給与所得控除後の金額
        var C = 0;
        C = Math.round(Number(this.taxForm.income) - Number(A) - Number(B));
        this.taxForm.deduction3 = C.toLocaleString();

        //基礎控除
        var D = 0;
        D = C === 0 ? 0 : (C <= 24000000 ? 480000 : (C <= 24500000 ? 320000 : (C <= 25000000 ? 160000 : 0)));
        this.taxForm.deduction4 = D.toLocaleString();

        //配偶者控除
        var E = 0;
        if(C > 0 && C <= 10000000 && this.taxForm.spousal_income <= 1330000 &&this.taxForm.spousal_is_deductible != "無"){
          //配偶者特別控除
          if(this.taxForm.spousal_income > 480000){
            if(this.taxForm.spousal_income <= 950000){
              E = C <= 9000000 ? (380000) : (C <= 9500000 ? 260000 : 130000);
            
            }else if(this.taxForm.spousal_income >950000 && this.taxForm.spousal_income <= 1000000){
              E = C <= 9000000 ? (360000) : (C <= 9500000 ? 240000 : 120000);
            
            }else if(this.taxForm.spousal_income >1000000 && this.taxForm.spousal_income <= 1050000){
              E = C <= 9000000 ? (310000) : (C <= 9500000 ? 210000 : 110000);
            
            }else if(this.taxForm.spousal_income >1050000 && this.taxForm.spousal_income <= 1100000){
              E = C <= 9000000 ? (260000) : (C <= 9500000 ? 180000 : 90000);
            
            }else if(this.taxForm.spousal_income >1100000 && this.taxForm.spousal_income <= 1150000){
              E = C <= 9000000 ? (210000) : (C <= 9500000 ? 140000 : 70000);
            
            }else if(this.taxForm.spousal_income >1150000 && this.taxForm.spousal_income <= 1200000){
              E = C <= 9000000 ? (160000) : (C <= 9500000 ? 110000 : 60000);
            
            }else if(this.taxForm.spousal_income >1200000 && this.taxForm.spousal_income <= 1250000){
              E = C <= 9000000 ? (110000) : (C <= 9500000 ? 80000 : 40000);
            
            }else if(this.taxForm.spousal_income >1250000 && this.taxForm.spousal_income <= 1300000){
              E = C <= 9000000 ? (60000) : (C <= 9500000 ? 40000 : 20000);
            
            }else if(this.taxForm.spousal_income >1300000 && this.taxForm.spousal_income <= 1330000){
              E = C <= 9000000 ? (30000) : (C <= 9500000 ? 20000 : 10000);
            }
          //配偶者控除  
          }else if(this.taxForm.spousal_income <= 480000){
            if(this.taxForm.spousal_is_deductible === "有(一般)"){
              E = C <= 9000000 ? (380000) : (C <= 9500000 ? 260000 : 130000);
            }else if(this.taxForm.spousal_is_deductible === "有(老人70歳〜)"){
              E = C <= 9000000 ? (480000) : (C <= 9500000 ? 320000 : 160000);
          　}
          }
        }
        this.taxForm.deduction5 = E.toLocaleString();

        //扶養控除
        var F = Number(this.taxForm.number1) * 380000 + 
                Number(this.taxForm.number2) * 630000 + 
                Number(this.taxForm.number3) * 380000 +
                (Number(this.taxForm.number4) - Number(this.taxForm.number5)) * 480000 + 
                 Number(this.taxForm.number5) * 580000 ;
        this.taxForm.deduction6 = F.toLocaleString();

        //扶養障害者控除
        var G = Number(this.taxForm.number6) * 270000 +
                Number(this.taxForm.number7) - Number(this.taxForm.number8) * 400000 +
                Number(this.taxForm.number8) * 750000 ;
        this.taxForm.deduction7 = G.toLocaleString();
 
        //受給者障害者控除
        var receive1 = this.taxForm.disabled === "でない" ? 0 : (this.taxForm.disabled === "一般" ? 270000 : 400000 ) ;
        //受給者寡婦・ひとり親控除
        var receive2 = 0;
        if(C <= 5000000 ){
           receive2 = this.taxForm.single === "でない" ? 0 : (this.taxForm.single === "寡婦" ? 270000 : 350000 )
        }        
        //勤労学生
        var receive3 = this.taxForm.student === "でない" ? 0 : 270000;
        //受給者控除
　　　　 var H = receive1 + receive2 + receive3 ;
        this.taxForm.deduction8 = H.toLocaleString();

        //保険料等の控除
        this.taxForm.ins2 = this.taxForm.ins2 < 120000 ? this.taxForm.ins2 : 120000;
        this.taxForm.ins3 = this.taxForm.ins3 < 50000 ? this.taxForm.ins3 : 50000;
        var I = Number(this.taxForm.ins1) + Number(this.taxForm.ins2) + Number(this.taxForm.ins3);
        this.taxForm.deduction9 = I.toLocaleString();

        //所得控除の金額の合計額
        var J = Number(D) + Number(E) + Number(F) + Number(G) + Number(H) + Number(I) ;
        this.taxForm.amount1 = J.toLocaleString();

        //課税される所得金額
        var K = Number(C) - Number(J);
        //1,000円未満端数切捨て
        K = K - K % 1000;
        this.taxForm.amount2 = K.toLocaleString();

        //所得税額
        var L = 0;
        if(K >= 1000 && K <= 1949000){
          L = Number(K) * 0.05

        }else if(K >= 1950000 && K <= 3299000){
          L = Number(K) * 0.1 - Number(97500);
        }else if(K >= 3300000 && K <= 6949000){
          L = Number(K) * 0.2 - Number(427500);

        }else if(K >= 6950000 && K <= 8999000){
          L = Number(K) * 0.23 - Number(636000);

        }else if(K >= 9000000 && K <= 17999000){
          L = Number(K) * 0.33 - Number(1536000);

        }else if(K >= 18000000 && K <= 39999000){
          L = Number(K) * 0.4 - Number(2796000);

        }else if(K >= 40000000){
          L = Number(K) * 0.45 - Number(4796000);
        }
        this.taxForm.amount3 = Math.round(L).toLocaleString();


        //住宅取得等特別控除
        var M = this.taxForm.house;
        this.taxForm.deduction10 = M.toLocaleString();

        //所得税額-住宅取得等特別控除
        var amount4 = Number(L) - Number(M);

        //源泉徴収税額
        var N = amount4 + amount4 * 0.021;
        //100円未満端数切捨て
        N = N - N % 100;
        this.taxForm.tax1 = N.toLocaleString();

        //復興特別所得税
        var O = amount4 * 0.021;
        O = O - O % 100;
        this.taxForm.tax2 = O.toLocaleString();
      }      
    },
    
    clear() {
      this.ruleForm = {
        age: "0",
        basic_salary: "",
        salary: "",
        hSalaryType: "給与",
        salaryType: "給料",
        address: "東京都",
        date: "",
        h_half: "",
        c_half: "",
        h_c_half: "",
        h_total: "",
        c_total: "",
        h_c_total: "",
        annuity_half: "",
        annuity_total: "",
        type: "一般",
        annuity_half_rate: "",
        annuity_total_rate: "",
        tax:"",
        dependent_number:"",
      }
    },
    clear_tax() {
      this.taxForm = {
        taxFormDate:"令和2年",
        income:0,
        disabled:"でない",
        single:"でない",
        student:"でない",
        spousal_is_deductible:"無",
        spousal_income:0,
        number1:0,
        number2:0,
        number3:0,
        number4:0,
        number5:0,
        number6:0,
        number7:0,
        number8:0,
        number9:0,
        ins1:0,
        ins2:0,
        ins3:0,
        house:0,
        income1:"",
        deduction1:"",
        deduction2:"",
        deduction3:"",
        deduction4:"",
        deduction5:"",
        deduction6:"",
        deduction7:"",
        deduction8:"",
        deduction9:"",
        deduction10:"",
        amount1:"",
        amount2:"",
        amount3:"",
        tax1:"",
        tax2:""
      }
    }    
    
  },
  created() {
  },

};

</script>

<style scoped>
.register-container {
  border-radius: 15px;
  background-clip: padding-box;
  margin: 100px auto;
  width: 420px;
  height: 520px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
}
.social-container {
  border-radius: 15px;
  background-clip: padding-box;
  margin: auto auto;
  /* width:420px;
  height: 420px; */
  width:60%;
  height: 60%; 
  padding: 35px 35px 15px 35px;
  background: #fff;
}
.social-container-a{
  border-radius: 15px;
  background-clip: padding-box;
  margin: auto auto;
  /* width: 420px;
  height: 300px; */
  width: 60%;
  height: 45%;
  padding: 35px 35px 15px 35px;
  background: #fff;  
}
table,
th,
td {
  border: 1px solid #d3d3d3;
  border-collapse: collapse;
}
.th_style {
  background-color: #d9edfd;
  text-align: center;
  font-size: 14px;
  height: 20px;
}
td {
  text-align: center;
  font-size: 14px;
  height: 20px;
}
.hint_style{
  text-align:left;
  background: #d9edfd;
}
.hint_style_a{
  text-align:left;
  height: 25px;
  padding-left: 10px;  
}
.hint_style_b{
  text-align:left;
  background: #fff;
  padding-left: 10px;  
}
.hint_style_c{
  text-align:left;
  height: 12px;
  padding-left: 10px;  
}
.hint_style_d{
  text-align:left;
  background: #fff; 
}
a {
  text-decoration: none;
}
</style>


// WEBPACK FOOTER //
// src/components/Website/Calculator.vue